/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC41IDBWM0gxNS41VjRIMC41VjNINS41VjBIMTAuNVpNNi41IDFWM0g5LjVWMUg2LjVaTTEzLjUgMTVIMi41VjZIMS41VjE1LjVDMS41IDE1Ljc3NjEgMS43MjM4NiAxNiAyIDE2SDE0QzE0LjI3NjEgMTYgMTQuNSAxNS43NzYxIDE0LjUgMTUuNVY2SDEzLjVWMTVaTTguNSA3SDcuNVYxM0g4LjVWN1pNMTAuNSA3SDExLjVWMTNIMTAuNVY3Wk01LjUgN0g0LjVWMTNINS41VjdaIiBmaWxsPSJpbmhlcml0Ii8+";